import React, { useState } from 'react'
import TextFieldUniversal from '../../../validate/form/text/TextFieldUniversal'

const PackFormOrderId = ({ required, setValidate, setValueForm, forciblyValue }) => {

	const [value, setValue] = useState('')

  return (
	<TextFieldUniversal
        value={value}
        setValue={e => {
            setValueForm(e)
            setValue(e)
        }}
        setValidate={setValidate}
        label={'№ замовлення KeyCRM'} 
        placeholder={'Вкажіть номер замовлення (цифра)'}
        validates={{
            isEmpty: true,
            isDigit: true,
        }}
        forciblyValue={forciblyValue}
        required={required}
    />
  )
}

export default PackFormOrderId